import React from "react";
import {
  Alert,
  Box,
  Button,
  Card,
  CardContent,
  Checkbox,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormControlLabel,
  Stack,
  Typography,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { Person as PersonIcon } from "@mui/icons-material";
import StatuteHighlights from "../components/StatuteHighlights";
import LessonLocation from "../components/LessonLocation";

const SimpleConfirmDialog = ({
  open,
  onClose,
  header,
  dateLine,
  body,
  loading,
  onConfirm,
  acceptRegulamin,
  setAcceptRegulamin,
  lessonData,
  AcceptRegulaminLabel,
  extraContent = null,
  confirmLabel = "Zapisz się",
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  
  return (
    <Dialog 
      open={open} 
      onClose={onClose} 
      fullWidth 
      maxWidth="sm"
      PaperProps={{
        sx: {
          borderRadius: 2,
          m: isMobile ? 2 : 3,
        }
      }}
    >
      <DialogTitle sx={{ 
        textAlign: 'center', 
        pb: 1,
        pt: 3,
      }}>
        <Typography variant={isMobile ? "h6" : "h5"} fontWeight="600" gutterBottom>
          {header}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {dateLine}
        </Typography>
        {lessonData?.trainer?.full_name && (
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 0.5, mt: 0.5 }}>
            <PersonIcon sx={{ fontSize: 16, color: 'text.secondary' }} />
            <Typography variant="body2" color="text.secondary" fontWeight="500">
              {lessonData.trainer.full_name}
            </Typography>
          </Box>
        )}
      </DialogTitle>
      
      <DialogContent sx={{ pt: 2, pb: 3 }}>
        <Stack spacing={2.5}>
          {/* Location information */}
          {lessonData?.lesson_type?.location && (
            <LessonLocation location={lessonData.lesson_type.location} />
          )}
          
          <Typography variant="body1" sx={{ px: 1 }}>
            {body}
          </Typography>

          {extraContent}

          <StatuteHighlights />
          
          {/* Regulamin - Mobile only */}
          {isMobile && (
            <>
              <Divider />
              <FormControlLabel
                control={
                  <Checkbox 
                    checked={acceptRegulamin} 
                    onChange={(e) => setAcceptRegulamin(e.target.checked)} 
                  />
                }
                label={AcceptRegulaminLabel}
                sx={{ mx: 0 }}
              />
            </>
          )}
        </Stack>
      </DialogContent>
      
      <DialogActions sx={{ 
        px: 3, 
        pb: 3, 
        gap: 1,
        flexDirection: isMobile ? 'column' : 'row',
        justifyContent: 'space-between',
        alignItems: 'center'
      }}>
        {/* Regulamin checkbox - Desktop only */}
        {!isMobile && (
          <FormControlLabel
            control={
              <Checkbox 
                checked={acceptRegulamin} 
                onChange={(e) => setAcceptRegulamin(e.target.checked)} 
                size="small"
              />
            }
            label={AcceptRegulaminLabel}
            sx={{ mr: 'auto' }}
          />
        )}
        
        <Box sx={{ 
          display: 'flex', 
          gap: 1,
          width: isMobile ? '100%' : 'auto',
          flexDirection: isMobile ? 'column' : 'row'
        }}>
          <Button 
            onClick={onClose} 
            variant="outlined"
            fullWidth={isMobile}
            sx={{ minHeight: 44 }}
          >
            Anuluj
          </Button>
          <Button 
            onClick={onConfirm} 
            color="success" 
            variant="contained" 
            disabled={loading || !acceptRegulamin}
            fullWidth={isMobile}
            sx={{ minHeight: 44 }}
          >
            {loading ? <CircularProgress size={20} color="inherit" /> : confirmLabel}
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
};

export default SimpleConfirmDialog;
